import React from 'react'
import { Formik, Field, Form, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import styled from 'styled-components'
const Button = styled('button')`
  background-color: #45c1b8;
  border-color: 40a9ff;
  border-radius: 2px;
  &:hover {
    background-color: #40a9ff;
  }
`
const ReportProblemForm = ({ onSubmit, labelTitle }) => (
  <Formik
    initialValues={{
      problems: ''
    }}
    onSubmit={(values, { resetForm }) => {
      onSubmit(values)
      resetForm()
    }}
    validationSchema={Yup.object().shape({
      problems: Yup.string().required('กรุณาระบุรายละเอียดของปัญหา')
    })}
    render={({ errors, status, touched }) => (
      <Form>
        <div className="form-group" className="text-center">
          <label htmlFor="problems">{labelTitle ? labelTitle : 'โปรดระบุปัญหาที่ท่านต้องการแจ้งให้ Call Center ดำเนินการแก้ไข'}</label>
          <Field name="problems" type="text" className={`form-control${errors.problems && touched.problems ? ' is-invalid' : ''} my-3`} />
          <ErrorMessage name="problems" component="div" className="invalid-feedback" />
        </div>

        <div className="form-group text-right">
          <Button type="submit" className="btn btn-primary">
            ยืนยัน
          </Button>
        </div>
      </Form>
    )}
  />
)

export default ReportProblemForm
